module.exports = __webpack_public_path__ + "static/media/2nd-dot.775ec942.png";